//for onboarding urls

import Onboarding from '@/pages/Onboarding'
import Home from '@/pages/Timeline' //default view

export default {
  path: '/securedrss91',
  component: Onboarding,
  children: [
    {
      path: '',
      name: 'Onboarding',
      component: Home,
    },
    {
      path: 'gr/:grname/:gref/:ref',
      name: 'RefGroup',
      component: Onboarding,
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/onboarding.js